export class Action {
    constructor(actionType, anchor, info, strokeWidth) {
        this.actionType = actionType
        this.anchor = anchor
        this.info = info
        this.strokeWidth = strokeWidth
        this.text = ""
    }
}